import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import LocalActivityIcon from "@material-ui/icons/LocalActivity";
import GroupIcon from "@material-ui/icons/Group";
import SearchIcon from "@material-ui/icons/Search";
import PersonIcon from "@material-ui/icons/Person";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import PeopleIcon from "@material-ui/icons/People";
import StarIcon from "@material-ui/icons/Star";
import NetworkCheckIcon from '@material-ui/icons/NetworkCheck';
import SmallCard from "../../atoms/smallCard";
import StatCard from "../../atoms/statCard";
import { tooltips } from "../../constants/tooltips";
import { colours } from "../../utilities/styles";

const DashboardStats = ({ statistics }) => {
  const {
    total_training_activities,
    active_30_days_users,
    total_members,
    total_active_members,
    group_ids,
    completed_feed_forwards,
    total_feed_forwards,
    total_weekly_reflections,
    feed_forward_habit_index_avg,
    feed_forward_last90days_habit_index_avg,
    feed_forward_trust_nps,
    feed_forward_last90days_trust_nps_avg,

  } = statistics;
  const habitIndexValue = feed_forward_last90days_habit_index_avg || feed_forward_habit_index_avg;
  const trustNPSValue = feed_forward_last90days_trust_nps_avg || feed_forward_trust_nps;

  return (
    <>
      <Grid container spacing={3} >
        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <StatCard
          stat={habitIndexValue ? Math.round(habitIndexValue) : "N/A"}
          title="Habit Index"
          image={
            <NetworkCheckIcon
              fontSize="large"
              style={{ marginBottom: "10px", fill: colours.yomento_purple }}
            />
          }
          tooltip={tooltips.totalHabitIndex}
        />
        </Grid>
        <Grid item xs={2}>
          <StatCard
            stat={trustNPSValue ? Math.round(trustNPSValue) : "N/A"}          
            title="Trust NPS"
            image={
            <NetworkCheckIcon
              fontSize="large"
              style={{ marginBottom: "10px", fill: colours.yomento_purple }}
            />
          }
          tooltip={tooltips.totalTrustNPS}
        />
        </Grid>
        <Grid item xs={4}></Grid>       
      </Grid>

      <Grid item xs={4}>
        <StatCard
          stat={total_training_activities}
          title="Total training activities"
          image={
            <LocalActivityIcon
              fontSize="large"
              style={{ marginBottom: "10px", fill: colours.yomento_purple }}
            />
          }
          tooltip={tooltips.totalActivities}
        />
      </Grid>
      <Grid item xs={4}>
        <StatCard
          stat={`${active_30_days_users} / ${(
            (100 * active_30_days_users) /
            total_active_members
          ).toFixed(0)}%`}
          title="Active last 90 days"
          image={
            <GroupIcon
              fontSize="large"
              style={{ marginBottom: "10px", fill: colours.yomento_purple }}
            />
          }
          tooltip={tooltips.activeLast30Days}
        />
      </Grid>
      <Grid item xs={4}>
        <StatCard
          stat={total_weekly_reflections}
          title="Activities per leader last 30 days"
          image={
            <SearchIcon
              fontSize="large"
              style={{ marginBottom: "10px", fill: colours.yomento_purple }}
            />
          }
          tooltip={tooltips.activitiesLast30Days}
        />
      </Grid>

      <Grid item xs={3}>
        <SmallCard
          stat={total_members}
          title="Total members"
          image={
            <PersonIcon
              fontSize="large"
              style={{ marginRight: "10px", fill: colours.yomento_purple }}
            />
          }
          tooltip={tooltips.totalMembers}
        />
      </Grid>
      <Grid item xs={3}>
        <SmallCard
          stat={total_active_members}
          title="Logged in"
          image={
            <ExitToAppIcon
              fontSize="large"
              style={{ marginRight: "10px", fill: colours.yomento_purple }}
            />
          }
          tooltip={tooltips.loggedIn}
        />
      </Grid>
      <Grid item xs={3}>
        <SmallCard
          stat={group_ids.length}
          title="Groups"
          image={
            <PeopleIcon
              fontSize="large"
              style={{ marginRight: "10px", fill: colours.yomento_purple }}
            />
          }
          tooltip={tooltips.groups}
        />
      </Grid>
      <Grid item xs={3}>
        <SmallCard
          stat={`${total_feed_forwards} / ${completed_feed_forwards}`}
          title="Habit profile"
          image={
            <StarIcon
              fontSize="large"
              style={{ marginRight: "10px", fill: colours.yomento_purple }}
            />
          }
          tooltip={tooltips.habitProfiles}
        />
      </Grid>
    </>
  );
};

DashboardStats.propTypes = {
  statistics: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default DashboardStats;
